import fragmentPrices from '~/modules/GraphQL/customQueries/fragments/fragmentPrices';

export default `
  query customerRequestQuotes($currentPage: Int = 1, $filter: CustomerQuotesFilterInput = {}, $pageSize: Int = 10) {
    customer {
      request_quotes(currentPage: $currentPage, filter: $filter, pageSize: $pageSize) {
        items {
          number
          id
          quote_date
          submited_date
          notes {
            admin_note
            customer_note
          }
          status
          expired_date
          prices {
            ...CartPrices
          }
          items {
            approved_price {
              currency
              value
            }
            original_price {
              currency
              value
            }
            requested_price {
              currency
              value
            }
            hide_price
            id
            notes {
              admin_note
              customer_note
            }
            product_name
            quantity
            quote_discount_amount {
              currency
              value
            }
            quote_discount_percent
            sku
            subtotal {
              currency
              value
            }
          }
        }
      page_info {
        current_page
        total_pages
        page_size
      }
      total_count
      }
    }
  }
${fragmentPrices}
`;
